import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

const WorkSessionEditReview = ({
  isWorkSessionEditReviewEnabled,
  handleWorkSessionEditReview,
}) => (
  <Row>
    <Col>
      <h4 className="font-weight-base mb-1">Worksession request review</h4>
      <small className="text-muted">
        Enable this setting to add a review step to the worksession edit request
        flow on the Timesheet -{'>'} Worksession Edit Requests page. Requests
        must be reviewed before they can be approved.
      </small>
    </Col>
    <Col className="col-auto">
      <div className="form-check form-switch">
        <input
          className="form-check-input toggle-switch"
          type="checkbox"
          id="workSessionEditReview"
          name="workSessionEditReview"
          checked={isWorkSessionEditReviewEnabled}
          onChange={handleWorkSessionEditReview}
        />
      </div>
    </Col>
  </Row>
);
WorkSessionEditReview.propTypes = {
  isWorkSessionEditReviewEnabled: PropTypes.bool,
  handleWorkSessionEditReview: PropTypes.func,
};
export default WorkSessionEditReview;
